"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Logger_1 = require("../../utils/Logger");
const MetaValidator_1 = __importDefault(require("../../utils/MetaValidator"));
const Secrets_1 = __importDefault(require("../Secrets"));
function PostConstruct(definition, name, descriptor) {
    MetaValidator_1.default.checkDef(definition, 'PostConstruct');
    if (Secrets_1.default.getPostContruct(definition)) {
        (0, Logger_1.error)(`The class '${definition.constructor.name}' must constains no more than one PostConstruct method.`);
    }
    Secrets_1.default.setPostContruct(definition, name);
    return descriptor;
}
exports.default = PostConstruct;
//# sourceMappingURL=PostConstruct.js.map